import React from "react";
import {useParams} from "react-router-dom";
import {BASE_URL} from "../../../../helpers/Api";


const Documentos = ({}) => {
    const params = useParams();
    const idAgente = params.id
  return (
    <div className="row">
    <div className="col-12 m-3">
      <h6>Panel de generación de documentos</h6>
        <p>
          Descargue los documentos que requiera dando click en cualquiera de las tres opciones.
        </p>
        </div>
      <div className="col-12 m-1">
          <a href={`${BASE_URL}/generar-pagare/${idAgente}/` } target={"_blank"} className="btn btn-primary  m-2">
                Generar pagaré
          </a>
          <a href={`${BASE_URL}/generar-anexo/${idAgente}/` } target={"_blank"} className="btn btn-primary m-2">
              Generar anexo
          </a>
          <a href={`${BASE_URL}/generar-contrato/${idAgente}/` } target={"_blank"} className="btn btn-primary m-2">
              Generar contrato
          </a>
      </div>
    </div>
  );
};

export default Documentos;
